import { ControlProperty, DatepickerRangeModel, DatepickerRangeOutput } from '../../../../../common/models';
import {
  TransportListFiltersDatepickerRangeModel,
  TransportListFiltersDatepickerRangeOutput,
} from '../../transport/models';
import { DeviationType, MonitoringFilterNameDictionary } from '../../../../models';
import { DraggableFilterType, MonitoringStatus } from '../../../../constants';
import { AutomotiveAftermarketRangeDate } from '../constants';
import {
  ArrivalsDepartureGroupsName,
  AutomotiveAftermarketOrigin,
  TransportFilterName,
} from '../../transport/constants';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  DEFAULT_PAGE_SIZE_OPTIONS,
  ListQueryParam,
  ShipmentTransportMode,
  TransportMode,
} from '../../../../../common/constants';
import { DeliveryService, Origin, ServiceLevel } from '../../transport/constants/transport-list.constant';
import { FreightMode } from '../../../shipment-transport-order/constants';
import { assignObjectIfPropertyValueValid } from '../../../../../common';
import { AutomotiveAftermarketTypeView, AutomotiveAftermarketTypeViewType } from './automotive-aftermarket-list.model';

export class AutomotiveAftermarketTileTypeModel {
  load = false;
  transportOrder = false;
  deliveryNote = true;
  handlingUnit = false;
  constructor(params?: AutomotiveAftermarketTypeViewType[]) {
    if (params && params.length) {
      this.load = false;
      this.transportOrder = false;
      this.deliveryNote = false;
      this.handlingUnit = false;
      params.forEach((param: AutomotiveAftermarketTypeViewType) => {
        const tileTypeEntry: [string, AutomotiveAftermarketTypeViewType] = Object.entries(
          AutomotiveAftermarketTypeView,
        ).find(([_, value]: [string, AutomotiveAftermarketTypeViewType]) => value === param);
        if (tileTypeEntry) {
          const [tileTypeKey]: [string, AutomotiveAftermarketTypeViewType] = tileTypeEntry;
          this[tileTypeKey[0].toLowerCase() + tileTypeKey.slice(1)] = true;
        }
      });
    }
  }
}

export class AutomotiveAftermarketTileTypeFormGroup {
  constructor(
    model: AutomotiveAftermarketTileTypeModel,
    public load: ControlProperty<boolean> = [model.load, []],
    public transportOrder: ControlProperty<boolean> = [model.transportOrder, []],
    public deliveryNote: ControlProperty<boolean> = [model.deliveryNote, []],
    public handlingUnit: ControlProperty<boolean> = [model.handlingUnit, []],
  ) {}
}

export const TILE_TYPE_KEY = 'tileType';

export const AutomotiveAftermarketDateRangeFilter = {
  ...ArrivalsDepartureGroupsName,
  ...AutomotiveAftermarketRangeDate,
};
export type AutomotiveAftermarketDateRangeFilter = ArrivalsDepartureGroupsName | AutomotiveAftermarketRangeDate;

export type AutomotiveAftermarketGroupTimestampValues = {
  [key in AutomotiveAftermarketDateRangeFilter]: DatepickerRangeModel;
};
export type AutomotiveAftermarketGroupDateValues = {
  [key in AutomotiveAftermarketDateRangeFilter]: DatepickerRangeOutput;
};

export const AUTOMOTIVE_AFTERMARKET_FILTER_TYPE_BY_NAME: Map<MonitoringFilterNameDictionary, DraggableFilterType> =
  new Map([
    [MonitoringFilterNameDictionary.Consignors, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.Consignees, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.ShipTos, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.Pickups, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.EquipmentId, DraggableFilterType.Input],
    [MonitoringFilterNameDictionary.HuIds, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.RbPoNumber, DraggableFilterType.Input],
    [MonitoringFilterNameDictionary.StatusDate, DraggableFilterType.RangeDatepicker],
    [MonitoringFilterNameDictionary.UnNumber, DraggableFilterType.Input],
    [MonitoringFilterNameDictionary.TransportNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.LspTrackingNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.RouteIds, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.TransportOrderNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.LoadNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.BoschMaterialNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.DeliveryNoteNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.HouseAirwayBills, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.IStarNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.BarcodeIds, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.TransportModes, DraggableFilterType.MultipleSelect],
    [MonitoringFilterNameDictionary.Origins, DraggableFilterType.MultipleSelect],
    [MonitoringFilterNameDictionary.Statuses, DraggableFilterType.MultipleSelect],
    [MonitoringFilterNameDictionary.FreightModes, DraggableFilterType.MultipleSelect],
    [MonitoringFilterNameDictionary.ServiceLevels, DraggableFilterType.MultipleSelect],
    [MonitoringFilterNameDictionary.DeliveryServices, DraggableFilterType.MultipleSelect],
    [MonitoringFilterNameDictionary.DeviationTypes, DraggableFilterType.MultipleSelect],
    [MonitoringFilterNameDictionary.Carriers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.ReasonCodes, DraggableFilterType.ChipsInputPopup],
    [MonitoringFilterNameDictionary.StatusCodes, DraggableFilterType.ChipsInputPopup],
    [MonitoringFilterNameDictionary.EstimatedDepartureTime, DraggableFilterType.RangeDatepicker],
    [MonitoringFilterNameDictionary.EstimatedArrivalTime, DraggableFilterType.RangeDatepicker],
    [MonitoringFilterNameDictionary.ActualDepartureTime, DraggableFilterType.RangeDatepicker],
    [MonitoringFilterNameDictionary.ActualArrivalTime, DraggableFilterType.RangeDatepicker],
    [MonitoringFilterNameDictionary.PlannedDepartureTime, DraggableFilterType.RangeDatepicker],
    [MonitoringFilterNameDictionary.PlannedArrivalTime, DraggableFilterType.RangeDatepicker],
    [MonitoringFilterNameDictionary.BoschOrderNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.CustomerOrderNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.CustomerMaterialNumbers, DraggableFilterType.ChipsInput],
    [MonitoringFilterNameDictionary.SapIds, DraggableFilterType.ChipsInputSearchGenericWithCheckboxes],
  ]);

export class AutomotiveAftermarketListFiltersModel extends TransportListFiltersDatepickerRangeModel {
  [MonitoringFilterNameDictionary.HuIds]: string[] = [];
  [MonitoringFilterNameDictionary.EquipmentId] = '';
  [MonitoringFilterNameDictionary.RbPoNumber] = '';
  [MonitoringFilterNameDictionary.UnNumber] = '';
  [MonitoringFilterNameDictionary.ShipTos]: string[] = [];
  [MonitoringFilterNameDictionary.TransportNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.LspTrackingNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.RouteIds]: string[] = [];
  [MonitoringFilterNameDictionary.StatusDate] = new DatepickerRangeModel();
  [MonitoringFilterNameDictionary.ReasonCodes]: string[] = [];
  [MonitoringFilterNameDictionary.StatusCodes]: string[] = [];
  [MonitoringFilterNameDictionary.DeviationTypes]: DeviationType[] = [];
  [MonitoringFilterNameDictionary.BarcodeIds]: string[] = [];
  [MonitoringFilterNameDictionary.CustomerOrderNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.CustomerMaterialNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.BoschOrderNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.BoschMaterialNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.SapIds]: string[] = [];
  [TILE_TYPE_KEY] = new AutomotiveAftermarketTileTypeModel();

  constructor(params?: AutomotiveAftermarketListFiltersModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export const AUTOMOTIVE_AFTERMARKET_FILTER_SELECT_OPTIONS_BY_NAME = new Map<TransportFilterName, string[]>([
  [TransportFilterName.FreightModes, Object.values(FreightMode)],
  [TransportFilterName.TransportModes, Object.values(ShipmentTransportMode)],
  [TransportFilterName.Statuses, Object.values(MonitoringStatus)],
  [TransportFilterName.ServiceLevels, Object.values(ServiceLevel)],
  [TransportFilterName.DeliveryServices, Object.values(DeliveryService)],
  [TransportFilterName.Origins, Object.values(AutomotiveAftermarketOrigin)],
  [TransportFilterName.DeviationTypes, Object.values(DeviationType)],
]);

export class AutomotiveAftermarketListFiltersApiModel extends TransportListFiltersDatepickerRangeModel {
  [MonitoringFilterNameDictionary.HuIds]: string[] = [];
  [MonitoringFilterNameDictionary.EquipmentId] = '';
  [MonitoringFilterNameDictionary.RbPoNumber] = '';
  [MonitoringFilterNameDictionary.UnNumber] = '';
  [MonitoringFilterNameDictionary.ShipTos]: string[] = [];
  [MonitoringFilterNameDictionary.TransportNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.LspTrackingNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.RouteIds]: string[] = [];
  [MonitoringFilterNameDictionary.StatusDate] = new DatepickerRangeModel();
  [MonitoringFilterNameDictionary.ReasonCodes]: string[] = [];
  [MonitoringFilterNameDictionary.StatusCodes]: string[] = [];
  [MonitoringFilterNameDictionary.DeviationTypes]: DeviationType[] = [];
  [MonitoringFilterNameDictionary.BarcodeIds]: string[] = [];
  [MonitoringFilterNameDictionary.CustomerOrderNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.CustomerMaterialNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.BoschOrderNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.BoschMaterialNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.SapIds]: string[] = [];
  [TILE_TYPE_KEY]: AutomotiveAftermarketTypeViewType[];

  constructor(params?: AutomotiveAftermarketListFiltersApiModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AutomotiveAftermarketListRequestModel extends AutomotiveAftermarketListFiltersApiModel {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE_OPTIONS[1];
  [ListQueryParam.Page] = 0;
}

export class AutomotiveAftermarketListFiltersDynamicFormModel {
  [TILE_TYPE_KEY] = new AutomotiveAftermarketTileTypeModel();

  constructor(params?: MonitoringFilterNameDictionary[]) {
    if (params) {
      const defaultObjectValues = new AutomotiveAftermarketListFiltersFormDictionary(
        new AutomotiveAftermarketListFiltersModel(),
      );
      params.forEach((filterName: MonitoringFilterNameDictionary) => {
        this[filterName] = defaultObjectValues[filterName];
      });
    }
  }
}

export class AutomotiveAftermarketListFiltersModelOutput extends TransportListFiltersDatepickerRangeOutput {
  [MonitoringFilterNameDictionary.HuIds]: string[] = [];
  [MonitoringFilterNameDictionary.EquipmentId] = '';
  [MonitoringFilterNameDictionary.RbPoNumber] = '';
  [MonitoringFilterNameDictionary.UnNumber] = '';
  [MonitoringFilterNameDictionary.ShipTos]: string[] = [];
  [MonitoringFilterNameDictionary.TransportNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.LspTrackingNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.RouteIds]: string[] = [];
  [MonitoringFilterNameDictionary.ReasonCodes]: string[] = [];
  [MonitoringFilterNameDictionary.StatusCodes]: string[] = [];
  [MonitoringFilterNameDictionary.DeviationTypes]: DeviationType[] = [];
  [MonitoringFilterNameDictionary.BarcodeIds]: string[] = [];
  [MonitoringFilterNameDictionary.CustomerOrderNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.CustomerMaterialNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.BoschOrderNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.BoschMaterialNumbers]: string[] = [];
  [MonitoringFilterNameDictionary.SapIds]: string[] = [];
  [MonitoringFilterNameDictionary.StatusDate] = new DatepickerRangeOutput();
  [TILE_TYPE_KEY]: AutomotiveAftermarketTypeViewType[];

  constructor(params?: AutomotiveAftermarketListFiltersModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AutomotiveAftermarketProfileFilterModel extends AutomotiveAftermarketListFiltersApiModel {
  constructor(params?: AutomotiveAftermarketProfileFilterModel) {
    super();
    if (params) {
      assignObjectIfPropertyValueValid(this, params);
    }
  }
}

export class AutomotiveAftermarketListFiltersFormDictionary {
  constructor(
    model: AutomotiveAftermarketListFiltersModel,
    public transportModes: ControlProperty<TransportMode[]> = [model.transportModes, []],
    public deviationTypes: ControlProperty<DeviationType[]> = [model.deviationTypes, []],
    public freightModes: ControlProperty<FreightMode[]> = [model.freightModes, []],
    public statuses: ControlProperty<string[]> = [model.statuses, []],
    public serviceLevels: ControlProperty<ServiceLevel[]> = [model.serviceLevels, []],
    public origins: ControlProperty<Origin[]> = [model.origins, []],
    public deliveryServices: ControlProperty<DeliveryService[]> = [model.deliveryServices, []],
    public transportOrderNumbers: ControlProperty<string[]> = [model.transportOrderNumbers, []],
    public loadNumbers: ControlProperty<string[]> = [model.loadNumbers, []],
    public boschMaterialNumbers: ControlProperty<string[]> = [model.boschMaterialNumbers, []],
    public iStarNumbers: ControlProperty<string[]> = [model.iStarNumbers, []],
    public carriers: ControlProperty<string[]> = [model.carriers, []],
    public shipTos: ControlProperty<string[]> = [model.shipTos, []],
    public pickups: ControlProperty<string[]> = [model.pickups, []],
    public consignors: ControlProperty<string[]> = [model.consignors, []],
    public consignees: ControlProperty<string[]> = [model.consignees, []],
    public houseAirwayBills: ControlProperty<string[]> = [model.houseAirwayBills, []],
    public reasonCodes: ControlProperty<string[]> = [model.reasonCodes, []],
    public statusCodes: ControlProperty<string[]> = [model.statusCodes, []],
    public deliveryNoteNumbers: ControlProperty<string[]> = [model.deliveryNoteNumbers, []],
    public estimatedDepartureTime: ControlProperty<DatepickerRangeModel> = [model.estimatedDepartureTime, []],
    public estimatedArrivalTime: ControlProperty<DatepickerRangeModel> = [model.estimatedArrivalTime, []],
    public actualDepartureTime: ControlProperty<DatepickerRangeModel> = [model.actualDepartureTime, []],
    public actualArrivalTime: ControlProperty<DatepickerRangeModel> = [model.actualArrivalTime, []],
    public plannedDepartureTime: ControlProperty<DatepickerRangeModel> = [model.plannedDepartureTime, []],
    public plannedArrivalTime: ControlProperty<DatepickerRangeModel> = [model.plannedArrivalTime, []],
    public profileId: ControlProperty<number> = [model.profileId, []],

    public huIds: ControlProperty<string[]> = [model.huIds, []],
    public equipmentId: ControlProperty<string> = [model.equipmentId, []],
    public rbPoNumber: ControlProperty<string> = [model.rbPoNumber, []],
    public unNumber: ControlProperty<string> = [model.unNumber, []],
    public statusDate: ControlProperty<DatepickerRangeModel> = [model.statusDate, []],
    public tileType: UntypedFormGroup = new UntypedFormBuilder().group(
      new AutomotiveAftermarketTileTypeFormGroup(new AutomotiveAftermarketTileTypeModel()),
    ),
    public transportNumbers: ControlProperty<string[]> = [model.transportNumbers, []],
    public lspTrackingNumbers: ControlProperty<string[]> = [model.lspTrackingNumbers, []],
    public routeIds: ControlProperty<string[]> = [model.routeIds, []],
    public barcodeIds: ControlProperty<string[]> = [model.barcodeIds, []],
    public customerOrderNumbers: ControlProperty<string[]> = [model.customerOrderNumbers, []],
    public customerMaterialNumbers: ControlProperty<string[]> = [model.customerMaterialNumbers, []],
    public boschOrderNumbers: ControlProperty<string[]> = [model.boschOrderNumbers, []],
    public sapIds: ControlProperty<string[]> = [model.sapIds, []],
  ) {}
}

export class AutomotiveAftermarketListFiltersDynamicForm {
  tileType: UntypedFormGroup;

  constructor(model: AutomotiveAftermarketListFiltersDynamicFormModel) {
    if (model) {
      Object.assign(this, model);
      this.tileType = new UntypedFormBuilder().group(
        new AutomotiveAftermarketTileTypeFormGroup(new AutomotiveAftermarketTileTypeModel()),
      );
    }
  }
}
